import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

export interface UserState {
    /** 全局项目标题 **/
    title: string;
}

const useCommonStore = defineStore('common', () => {
    const title = ref<string>('FlagOS');
    const dropdownCount = ref(0);
    const unreadCount = ref(0);

    const realtimeStream = ref<string>('');
    const setRealtimeStream = (stream: any) => {
        realtimeStream.value = stream;
    };

    // Header popover 中的消息列表数据
    const headerMessageList = ref<any[]>([]);
    const setDropdownVisible = (visible: boolean) => {
        if (visible) {
            dropdownCount.value++;
        } else {
            dropdownCount.value--;
        }

        if (dropdownCount.value < 0) {
            dropdownCount.value = 0;
        }
    };

    const headerWhiteTheme = ref<boolean | null>(null);
    const setHeaderWhiteTheme = (val: boolean | null) => {
        headerWhiteTheme.value = val;
    };

    const dropdownVisible = computed(() => false);

    function setTitle(val: string) {
        val && (title.value = val);
        document.title = title.value;
    }
    function setUnreadCount(count: number) {
        unreadCount.value = count;
    }

    /**
     * 同步 Header 消息中心数据（用于 Header/MessageList 协同展示）
     */
    function updateHeaderMessageCenter(payload: { messageList?: any[]; unreadCount?: number }) {
        const { messageList, unreadCount: nextUnreadCount } = payload || {};
        if (messageList !== undefined) {
            headerMessageList.value = messageList;
        }
        if (typeof nextUnreadCount === 'number') {
            unreadCount.value = nextUnreadCount;
        }
    }

    return {
        title,
        setTitle,
        dropdownVisible,
        setDropdownVisible,
        unreadCount,
        setUnreadCount,
        headerMessageList,
        updateHeaderMessageCenter,
        realtimeStream,
        setRealtimeStream,
        headerWhiteTheme,
        setHeaderWhiteTheme,
    };
});

export default useCommonStore;
